import { useEffect, useState, useRef } from "react"
import { useNavigate } from "react-router-dom"
import Header from "../../common/Header"
import BackgroundVideo from "../../common/BackgroundVideo"
import MVRSidebar from "./MVRSidebar"
import MVRMiddleHeader from "./MVRMiddleHeader"
import { DataTable } from "primereact/datatable"
import AtkLoader from "../../AtlaskitControls/AtkLoader"
import AtkTextField from "../../AtlaskitControls/AtkTextField"
import AtkButton from "../../AtlaskitControls/AtkButton"
import { Column } from "primereact/column"
import axios from "axios"
import CommonValues from "../../common/utils"
import moment from "moment"
import { Toast } from "primereact/toast"
import PreviewIcon from "../../assets/images/ViewDetailsIcon.png";
import { Dialog } from "primereact/dialog"
import MVRDetailsPage from "./MVRDetailsPage"
import feedbackImg from "../../assets/images/feedback.svg";
import { OverlayPanel } from "primereact/overlaypanel";
import { saveAs } from "file-saver";
import DownloadIcon from "../../assets/images/icon _download_.png";
export default function MVRHistory(props: any) {
  const navigate = useNavigate();
  const toast: any = useRef("");
  const feedbackRef = useRef<OverlayPanel>(null);
  const [historyloading, setHistoryLoading] = useState(false);
  const [mvrhistorydata, setMVRHistoryData] = useState<any>([]);
  const [globalFilter, setGlobalFilter] = useState("");
  const [checkStatusLoading, setCheckStatusLoading] = useState(false);
  const [transactionId, setTransactionId] = useState("");
  const [personDetails, setPersonDetails] = useState<any>([]);
  const [voilationsDetails, setVoilationsDetails] = useState<any>([]);
  const [accidentsDetails, setAccidentsDetails] = useState<any>([]);
  const [licenseDetails, setLicenseDetails] = useState<any>([]);
  const [showDialog, setShowDialog] = useState(false);
  const [previewFileLoading, setPreviewFileLoading] = useState(false);
  const [feedbackError, setFeedbackError] = useState("");
  const [feedbackData, setFeedBackData] = useState<any>([]);
  const [feedBackError, setFeedBackError] = useState("");
  const [feedbackLoading, setFeedbackLoading] = useState(false);
  const [mVRReportPdfUrl,setMVRReportPdfUrl]=useState("");
  const [selectedApiType,setSelectedApiType]=useState("");


  useEffect(() => {
    getMVRHistory();
  }, []);

  const getMVRHistory = () => {
    setHistoryLoading(true);
    const token = CommonValues.GetToken();
    var config = {
      method: "get",
      url: `${process.env.REACT_APP_DataFabric_Url}/api/mvr/history`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    axios(config)
      .then((response: any) => {
        setMVRHistoryData(response.data);
        setHistoryLoading(false);
      })
      .catch((error: any) => {
        if (error.response != null) {
          if (error.response.status === 401) {
            CommonValues.Logout(navigate);
          } else {
            toast.current.show({ severity: "error", summary: 'Error', detail: "Unknown error while getting mvr history", life: 3000 });
          }
        }
        setHistoryLoading(false);
      });
  }

  const checkStatus = (rowData: any) => {
    setTransactionId(rowData.transactionId);
    setCheckStatusLoading(true);
    const token = CommonValues.GetToken();
    var config = {
      method: "get",
      url: `${process.env.REACT_APP_DataFabric_Url}/api/mvr/${rowData.apiType == "ActivityHistory" ? "orderstatus" : "mvrorderstatus"}?orderId=${rowData.orderId}&transactionId=${rowData.transactionId}`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    axios(config)
      .then((response: any) => {
        if(rowData.apiType == "ActivityHistory"){
        if (response.data.orderStatus == "fulfilled") {
          let reportId = response.data.links[0].id;
          getReport(reportId, rowData.transactionId, true, rowData.apiType);
        } else {
          setCheckStatusLoading(false);
        }
      }else{
        if (response.data.orderStatus == "fulfilled" || response.data.orderStatus == "error") {
          let reportId = response.data.links[0].id;
          getReport(reportId, rowData.transactionId, true, rowData.apiType);
        } else {
          setCheckStatusLoading(false);
        }
      }
      })
      .catch((error: any) => {
        if (error.response != null) {
          if (error.response.status === 401) {
            CommonValues.Logout(navigate);
          } else {
            toast.current.show({ severity: "error", summary: 'Error', detail: "Unknown error while check  mvr status history", life: 3000 });
          }
        }
        setCheckStatusLoading(false);
      });
  }

  const getReport = (reportId: any, transactionId: any, loadingFlag: any, apiType: any) => {
    if (loadingFlag == true) {
      setCheckStatusLoading(true);
    }
    const token = CommonValues.GetToken();
    var config = {
      method: "get",
      url: `${process.env.REACT_APP_DataFabric_Url}/api/mvr/${apiType == "ActivityHistory" ? "report" : "mvrreport"}?reportId=${reportId}&transactionId=${transactionId}`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    axios(config)
      .then((response: any) => {
        setCheckStatusLoading(false);
        getMVRHistory();
      })
      .catch((error: any) => {
        if (error.response != null) {
          if (error.response.status === 401) {
            CommonValues.Logout(navigate);
          } else {
            toast.current.show({ severity: "error", summary: 'Error', detail: "Unknown error while getting report history", life: 3000 });
          }
        }
        setCheckStatusLoading(false);
      });
  }

  const actionBody = (rowData: any) => {
    return rowData.status =="OrderPlace" || rowData.status =="Pending"  ? (
      <>
        {rowData.transactionId == transactionId && checkStatusLoading ? (
          <AtkLoader size={20} className="mt-1" />) : (
          <AtkButton label="Check Status" onClick={() => { checkStatus(rowData) }} className="pf-secondary-btn w-auto" />
        )}
      </>
    ) : (
      <>
      {rowData.status == "Success" ? (
        <>
       
        <img src={PreviewIcon} height={20} title="Preview" onClick={() => { onPreviewClick(rowData) }} className="show-cursor" />
        {/* :<img src={DownloadIcon} onClick={() => downloadReport(rowData)} title="Download MVR Report" className="me-2 show-cursor" />
       } */}
       </>
      ): <span className=" text-12 quote-not-span">Not Available</span>}
        </>
    );
  };

  const onHidePopupClicked = () => {
    setShowDialog(false);
  };

  const feedbackTemplate = (rowData: any) => {
    return <img src={feedbackImg} className=" show-cursor" onClick={(e) => onShowFeedbackPopup(e, rowData)} title="Feedback" />;
  };

  const statusTemplate = (rowData: any) => {
    return rowData.status === "Started" ? (
      <b className="text-warning">Started </b>
    ) : rowData.status === "OrderPlace" ? (
      <b className="text-info">Order Placed</b>
    ) : rowData.status === "CheckStatus" ? (
      <b className="text-info"> Check Status</b>
    ) : rowData.status === "Pending" ? (
      <b className="text-info">Pending</b>
    ): rowData.status === "Success" ? (
      <b className="text-success"> Success</b>
    ) : rowData.status === "Failed" ? (
      <b className="text-danger"> Failed</b>
    ) : null;
  };

  const apiTypeTemplate = (rowData: any) => {
    return rowData.apiType === "ActivityHistory" ? (
      <span>Activity History</span>
    ) : rowData.apiType === "TransactionalMVR" ? (
      <span>Transactional MVR</span>
    ) : <span>NA</span>
  }
  const clientNameTemplate=(rowData:any)=>{
    let selectionOptionJson=JSON.parse(rowData.selectionOptionJson)
    return rowData.selectionOptionJson != null ?
    (
      <span>{selectionOptionJson.clientName}</span>
    ): "NA"
    
  }
  const driverNameTemplate=(rowData:any)=>{
    let selectionOptionJson = JSON.parse(rowData.selectionOptionJson);
    let selectedDriverDetails = selectionOptionJson.selectedDriverDetails;

    if (
      !selectedDriverDetails ||
      (Array.isArray(selectedDriverDetails) && selectedDriverDetails.length === 0) ||
      (typeof selectedDriverDetails === "object" && !Array.isArray(selectedDriverDetails) && Object.keys(selectedDriverDetails).length === 0) ||
      (!Array.isArray(selectedDriverDetails) && !selectedDriverDetails.firstName && !selectedDriverDetails.lastName)
    ) {
      return "NA";
    }

    if (Array.isArray(selectedDriverDetails) && selectedDriverDetails.length > 0) {
      const driver = selectedDriverDetails[0];
      if (!driver.firstName && !driver.lastName) return "NA";
      return (
      <span>{`${driver.firstName || ""} ${driver.lastName || ""}`.trim()}</span>
      );
    }

    return (
      <span>{`${selectedDriverDetails.firstName || ""} ${selectedDriverDetails.lastName || ""}`.trim()}</span>
    );
  }


  const onFeedbackChange = (newFeedback: string) => {
    const feedback = { ...feedbackData, feedback: newFeedback };
    setFeedBackData(feedback);
    if (newFeedback.length == 0 || newFeedback.trim() === "") {
      setFeedBackError("Please enter your feedback");
    } else if (newFeedback.length > 0) {
      setFeedBackError("");
    }
  };

  const onThumbsUpClick = (rowData: any) => {
    let liked: any;
    if (rowData.isLiked === true) {
      liked = null;
    } else {
      liked = true;
    }
    rowData = { ...rowData, isLiked: liked };
    setFeedBackData(rowData);
    setMVRHistoryData((prevResponses: any) =>
      prevResponses.map((response: any) => (response.transactionId === rowData.transactionId ? { ...response, isLiked: liked } : response))
    );
    onSaveRatings(rowData);
  };

  const onThumbDownClick = (rowData: any) => {
    let liked: any;
    if (rowData.isLiked === false) {
      liked = null;
    } else {
      liked = false;
    }
    rowData = { ...rowData, isLiked: liked };
    setFeedBackData(rowData);
    onSaveRatings(rowData);
    setMVRHistoryData((prevResponses: any) =>
      prevResponses.map((response: any) => (response.transactionId === rowData.transactionId ? { ...response, isLiked: liked } : response))
    );
  };

  const onHideFeedbackPopup = () => {
    if (feedbackRef.current) {
      feedbackRef.current.hide();
      setFeedBackData([]);
    }
  };

  const onSubmitFeedbackClick = (rowData: any) => {
    if (rowData.feedback == null || rowData.feedback == "") {
      setFeedBackError("Please enter your feedback");
    } else if (rowData.feedback.length > 250) {
      setFeedBackError("Please provide your feedback within 250 character");
    } else {
      setFeedBackError("");
      setFeedbackLoading(true);
      setTransactionId(rowData.transactionId);
      onSaveFeedback(rowData);
    }
  };

  const onSaveFeedback = (rowData: any) => {
    const token = CommonValues.GetToken();
    const feedbackVal = rowData.feedback == null ? "" : rowData.feedback;
    let data = {
      TransactionId: rowData.transactionId,
      Feedback: feedbackVal,
    };

    let config = {
      method: "post",
      url: `${process.env.REACT_APP_DataFabric_Url}/api/mvr/feedback`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: data,
    };

    axios
      .request(config)
      .then((response) => {
        toast.current.show({ severity: "success", summary: "Success", detail: "Feedback Submitted successfully", life: 3000 });
        const feedback = { feedback: "", isLiked: null };
        setFeedbackLoading(false);
        setFeedBackData(feedback);
        onHideFeedbackPopup();
      })
      .catch((error: any) => {
        
        setFeedbackLoading(false);
        if (error.response != null) {
          if (error.response.status === 401) {
            CommonValues.Logout(navigate);
          } else {
            toast.current.show({ severity: "error", summary: "Error", detail: "Unknown error while submitting feedback", life: 3000 });
          }
        }
      });
  };

  const onSaveRatings = (rowData: any) => {
    const feedbackVal = rowData.feedback == null ? "" : rowData.feedback;
    const token = CommonValues.GetToken();
    let data = {
      TransactionId: rowData.transactionId,
      IsLiked: rowData.isLiked,
      Feedback: feedbackVal,
    };
    let config = {
      method: "post",
      url: `${process.env.REACT_APP_DataFabric_Url}/api/mvr/isliked`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: data,
    };

    axios
      .request(config)
      .then((response) => {
        toast.current.show({ severity: "success", summary: "Success", detail: "Feedback submitted successfully", life: 3000 });
        const feedback = { feedback: "", isLiked: rowData.isLiked };
        setFeedbackLoading(false);
        setFeedBackData(feedback);
        onHideFeedbackPopup();
      })
      .catch((error: any) => {
        
        setFeedbackLoading(false);
        if (error.response != null) {
          if (error.response.status === 401) {
            CommonValues.Logout(navigate);
          } else {
            toast.current.show({ severity: "error", summary: "Error", detail: "Unknown error while submitting ratings", life: 3000 });
          }
        }
      });
  };

  const onShowFeedbackPopup = (e: any, rowData: any) => {
    setFeedbackError("");
    const feedback = { ...rowData, feedback: "" };
    setFeedBackData(feedback);
    feedbackRef.current?.toggle(e);
  };

  const downloadReport=(rowData:any)=>{
    const transactionId = rowData.transactionId;
    const token = CommonValues.GetToken();
    axios({
      method: "get",
      url: `${process.env.REACT_APP_DataFabric_Url}/api/mvr/download?transactionId=${transactionId}`,
      responseType: "blob",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((response: any) => {
          saveAs(response.data,"MVR_Report.pdf");
      })
      .catch((error: any) => {
        
        if (error.response != null) {
          if (error.response.status === 401) {
            CommonValues.Logout(navigate);
          } else {
            toast.current.show({ severity: "error", summary: "Error", detail: "Unknown error download mvr report.", life: 3000 });
          }
        }
        setHistoryLoading(false);
      });
  }

  const onRefreshClick=()=>{
   getMVRHistory();
  }

  const onPreviewClick =(rowData:any)=>{
    setSelectedApiType(rowData.apiType)
    if(rowData.apiType =="ActivityHistory")
    {
      onActivityHistoryPreviewClick(rowData)
    }else{
      onTransactionalMVRPreviewClick(rowData)
    }
  }

  const onTransactionalMVRPreviewClick = (rowData: any) => {
    const transactionId = rowData.transactionId;
    setShowDialog(true);
    setPreviewFileLoading(true);
    const token = CommonValues.GetToken();
    axios({
      method: "post",
      url: `${process.env.REACT_APP_DataFabric_Url}/api/mvr/previewdocument/${transactionId}`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((response: any) => {
        setMVRReportPdfUrl(response.data.fileUrl)
        setPreviewFileLoading(false);
      })
      .catch((error: any) => {
        
        if (error.response != null) {
          if (error.response.status === 401) {
            CommonValues.Logout(navigate);
          } else {
            toast.current.show({ severity: "error", summary: "Error", detail: "Unknown error getting mvr report pdf", life: 3000 });
          }
        }
        setPreviewFileLoading(false);
      });
  };

  const onActivityHistoryPreviewClick = (rowData: any) => {
    setShowDialog(true);
    let mvrSuccessResponseJson = JSON.parse(rowData.mvrSuccessResponseJson);
    let personDetails = mvrSuccessResponseJson.publicRecord.person;
    let voilationsDetails: any = []
    let accidentsDetails: any = []
    let licenseDetails: any = []
    
    if (mvrSuccessResponseJson.publicRecord.violations != null) {
      mvrSuccessResponseJson.publicRecord.violations.map((item: any) => {
        let violationObj = {
          date: item.date,
          code: item.infractions[0].stateCode,
          description: item.infractions[0].description,
          location: item.location,
          speed: item.actualSpeed,
          acd: item.infractions[0].acd,
          avd: item.infractions[0].avd1
        }
        voilationsDetails.push(violationObj);
      }
      )
    }

    if (mvrSuccessResponseJson.courtRecord.violations != null) {
      mvrSuccessResponseJson.courtRecord.violations.map((item: any) => {
        let violationObj = {
          date: item.date,
          code: item.infractions.stateCode,
          description: item.infractions.description,
          location: item.location,
          speed: item.actualSpeed,
          acd: item.infractions[0].acd,
          avd: item.infractions[0].avd1
        }
        voilationsDetails.push(violationObj);
      }
      )
    }

    if (mvrSuccessResponseJson.publicRecord.accidents != null) {
      mvrSuccessResponseJson.publicRecord.accidents.map((item: any) => {
        let accidentObj = {
          date: item.date,
          location: item.location,
          code: item.infractions[0].stateCode,
          description: item.infractions[0].description,
          acd: item.infractions[0].acd,
          avd: item.infractions[0].avd1
        }
        accidentsDetails.push(accidentObj);
      }
      )
    }

    if(mvrSuccessResponseJson.publicRecord.licenseClasses !=null){
    if (mvrSuccessResponseJson.publicRecord.licenseClasses.commercial != null) {

      let licenseObj = {
        issueDate: mvrSuccessResponseJson.publicRecord.licenseClasses.commercial.license.issueDate || null,
        expirationDate: mvrSuccessResponseJson.publicRecord.licenseClasses.commercial.license.expirationDate || null,
        class: mvrSuccessResponseJson.publicRecord.licenseClasses.commercial.license.classCode || null,
        classDescription: mvrSuccessResponseJson.publicRecord.licenseClasses.commercial.license.classDescription || null,
        status: mvrSuccessResponseJson.publicRecord.licenseClasses.commercial.license.statusList?.[0]?.name || null,
        restrictions: mvrSuccessResponseJson.publicRecord.licenseClasses.commercial.license.restrictions?.[0]?.description || null,
        cdlMedicalType: mvrSuccessResponseJson.publicRecord.licenseClasses.commercial.license.cdlMedicalType || null,
        cdlMedicalExpirationDate: mvrSuccessResponseJson.publicRecord.licenseClasses.commercial.license.cdlMedicalExpirationDate || null,
      }

      licenseDetails.push(licenseObj);
    }else if (mvrSuccessResponseJson.publicRecord.licenseClasses.personal != null) {

      let licenseObj = {
        issueDate: mvrSuccessResponseJson.publicRecord.licenseClasses.personal.license.issueDate || null,
        expirationDate: mvrSuccessResponseJson.publicRecord.licenseClasses.personal.license.expirationDate || null,
        class: mvrSuccessResponseJson.publicRecord.licenseClasses.personal.license.classCode || null,
        classDescription: mvrSuccessResponseJson.publicRecord.licenseClasses.personal.license.classDescription || null,
        status: mvrSuccessResponseJson.publicRecord.licenseClasses.personal.license.statusList?.[0]?.name || null,
        restrictions: mvrSuccessResponseJson.publicRecord.licenseClasses.personal.license.restrictions?.[0]?.description || null,
        cdlMedicalType: mvrSuccessResponseJson.publicRecord.licenseClasses.personal.license.cdlMedicalType || null,
        cdlMedicalExpirationDate: mvrSuccessResponseJson.publicRecord.licenseClasses.personal.license.cdlMedicalExpirationDate || null,
      }

      licenseDetails.push(licenseObj);
    }else if (mvrSuccessResponseJson.publicRecord.licenseClasses.identification != null) {

      let licenseObj = {
        issueDate: mvrSuccessResponseJson.publicRecord.licenseClasses.identification.license.issueDate || null,
        expirationDate: mvrSuccessResponseJson.publicRecord.licenseClasses.identification.license.expirationDate || null,
        class: mvrSuccessResponseJson.publicRecord.licenseClasses.identification.license.classCode || null,
        classDescription: mvrSuccessResponseJson.publicRecord.licenseClasses.identification.license.classDescription || null,
        status: mvrSuccessResponseJson.publicRecord.licenseClasses.identification.license.statusList?.[0]?.name || null,
        restrictions: mvrSuccessResponseJson.publicRecord.licenseClasses.identification.license.restrictions?.[0]?.description || null,
        cdlMedicalType: mvrSuccessResponseJson.publicRecord.licenseClasses.identification.license.cdlMedicalType || null,
        cdlMedicalExpirationDate: mvrSuccessResponseJson.publicRecord.licenseClasses.identification.license.cdlMedicalExpirationDate || null,
      }

      licenseDetails.push(licenseObj);
    }else if (mvrSuccessResponseJson.publicRecord.licenseClasses.motorcycle != null) {

      let licenseObj = {
        issueDate: mvrSuccessResponseJson.publicRecord.licenseClasses.motorcycle.license.issueDate || null,
        expirationDate: mvrSuccessResponseJson.publicRecord.licenseClasses.motorcycle.license.expirationDate || null,
        class: mvrSuccessResponseJson.publicRecord.licenseClasses.motorcycle.license.classCode || null,
        classDescription: mvrSuccessResponseJson.publicRecord.licenseClasses.motorcycle.license.classDescription || null,
        status: mvrSuccessResponseJson.publicRecord.licenseClasses.motorcycle.license.statusList?.[0]?.name || null,
        restrictions: mvrSuccessResponseJson.publicRecord.licenseClasses.motorcycle.license.restrictions?.[0]?.description || null,
        cdlMedicalType: mvrSuccessResponseJson.publicRecord.licenseClasses.motorcycle.license.cdlMedicalType || null,
        cdlMedicalExpirationDate: mvrSuccessResponseJson.publicRecord.licenseClasses.motorcycle.license.cdlMedicalExpirationDate || null,
      }

      licenseDetails.push(licenseObj);
    }
  }

    setLicenseDetails(licenseDetails);
    setAccidentsDetails(accidentsDetails);
    setPersonDetails(personDetails);
    setVoilationsDetails(voilationsDetails);
  };


  return (
    <>
      <Toast ref={toast} />
      <div className="smart-scan-history-main-page">
        <Header pagename="smart-scan-history" />
        <div className="content-wrapper ">
          <BackgroundVideo />
          <div className="row  wrapper-main-row mx-auto wrapper-below-div  ">
            <div className="col-12">
              <MVRMiddleHeader />
            </div>
            <div className="row main-content-row mx-auto">
              <div className="col-lg-2 col-md-3 sidebar-col display-for-desktop">
                <MVRSidebar pagename="mvr-history" />
              </div>

              <div className="col-lg-10 col-md-12 col-sm-12 main-content-col ">
                <div className="row  mt-2 d-flex  align-items-end text-12 position-relative">
                  <div className="col-12  history-table mt-3">
                    {historyloading ? (
                      <div className="d-flex align-ietms-center justify-content-center overflow-hidden mt-5">
                        <AtkLoader />{" "}
                      </div>
                    ) : (
                      <>
                        <div className="row mb-3">
                          <div className="col-6">
                            <span className="p-input-icon-left w-50">
                              <i className="fa fa-search grid-search-icon" />
                              <AtkTextField
                                type="text"
                                id="txtfirstName"
                                name="globalFilter"
                                onChange={(e) => setGlobalFilter(e.target.value)}
                                value={globalFilter}
                                className="input-field"
                                placeholder="Search..."
                              />
                            </span>
                          </div>
                          <div className="col-6 text-end">
                            <AtkButton label="Refresh" onClick={onRefreshClick} className=" pf-primary-btn w-auto" />
                          </div>
                        </div>
                        <DataTable
                          value={mvrhistorydata}
                          paginator
                          paginatorTemplate="PrevPageLink PageLinks NextPageLink"
                          rows={10}
                          selectionMode="single"
                          globalFilter={globalFilter}
                          emptyMessage="No data available."
                        >
                          <Column
                            header="Submitted Date"
                            field="created"
                            body={(rowData) => {
                              const utcdate = moment.utc(rowData.created);
                              var localDate = moment(utcdate).local();
                              return <span className="justify-">{localDate.format("MM/DD/YYYY HH:mm")} </span>;
                            }}
                            sortable
                          ></Column>
                            <Column header="Client Name" field="selectionOptionJson.clientName" body={clientNameTemplate} sortable></Column>
                            <Column header="Driver Name"field="selectionOptionJson.selectedDriverDetails.firstName" body={driverNameTemplate} sortable></Column>
                          <Column header="API Type" field="apiType" body={apiTypeTemplate} sortable></Column>
                          <Column header="Status" field="status" body={statusTemplate} sortable></Column>
                          <Column header="Action" className="text-center" body={actionBody}></Column>
                          <Column header="Feedback" className="text-center" body={feedbackTemplate}></Column>
                        </DataTable>
                      </>
                    )}

                    <Dialog header="" visible={showDialog} className={`${selectedApiType == "ActivityHistory" ? "" :"mvr-history-preview-box"}`} style={{ width: "50vw", height: "83vh"}} onHide={onHidePopupClicked} draggable={false}>
                      {previewFileLoading ? (
                        <div className="d-flex align-items-center justify-content-center overflow-hidden">
                          <AtkLoader />
                        </div>
                      ) : (
                        <>
                      {selectedApiType == "ActivityHistory" ?
                      <>
                        <MVRDetailsPage
                          personDetails={personDetails}
                          voilationsDetails={voilationsDetails}
                          accidentsDetails={accidentsDetails}
                          licenseDetails={licenseDetails}
                          onHidePopupClicked={onHidePopupClicked} />
                      </>:
                    <iframe src={mVRReportPdfUrl} style={{ overflow:"scroll" ,height: "75vh", width: "100%" }} className="mt-2"></iframe> 
                      }</>)}
                    </Dialog>

                    <OverlayPanel ref={feedbackRef} className="commission-feedback-panel feedback-panel">
                      <div className="row mx-auto d-flex align-items-center mb-2">
                        <div className="col-12 feedback-header">
                          <h4>Feedback</h4>
                        </div>
                        <div className={"form-group col-12 mb-2 text-12"}>
                          <textarea
                            name="feedback"
                            onChange={(e) => onFeedbackChange(e.target.value)}
                            value={feedbackData.feedback}
                            className={`form-control comment-text ${feedBackError.length > 0 ? " validation-div " : ""}`}
                            rows={4}
                            placeholder="Enter your feedback here"
                          />
                          <span className="text-danger  text-12 mt-1">{feedBackError}</span>
                        </div>
                        <div className="col-4 d-flex justify-content-evenly">
                          <i
                            className={`show-cursor fa fa-thumbs-up commission-feedback-icon 
                                                  ${feedbackData.isLiked == true ? " active" : " "}`}
                            aria-hidden="true"
                            onClick={(e) => onThumbsUpClick(feedbackData)}
                          ></i>
                          <i
                            className={`show-cursor fa fa-thumbs-down commission-feedback-icon 
                                                    ${feedbackData.isLiked == false ? " active" : " "}`}
                            aria-hidden="true"
                            onClick={(e) => onThumbDownClick(feedbackData)}
                          ></i>
                        </div>
                        <div className="col-4 text-end p-2 pe-0  ">
                          <AtkButton label="Cancel" onClick={onHideFeedbackPopup} className="pf-secondary-btn w-auto" />
                        </div>
                        <div className="col-4 text-end p-2  ">
                          {feedbackLoading ? (
                            <div className="d-flex justify-content-center align-items-center">
                              <AtkLoader />
                            </div>
                          ) : (
                            <AtkButton label="Submit" onClick={() => onSubmitFeedbackClick(feedbackData)} className="pf-secondary-btn w-auto " />
                          )}
                        </div>
                      </div>
                    </OverlayPanel>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}